import type { FetchFn } from '@zenstackhq/client-helpers/fetch';
import { getAuthToken } from '../auth/AuthContext';

/** Custom fetch passed to QuerySettingsProvider so every ZenStack hook call carries the bearer token. */
export const authFetch: FetchFn = (input, init) => {
  const token = getAuthToken();
  const headers = new Headers(init?.headers);
  if (token) headers.set('Authorization', `Bearer ${token}`);
  return fetch(input, { ...init, headers });
};
